import { render, staticRenderFns } from "./CLtkSlideGroup.vue?vue&type=template&id=eb2d0ad0"
import script from "./CLtkSlideGroup.vue?vue&type=script&lang=ts"
export * from "./CLtkSlideGroup.vue?vue&type=script&lang=ts"
import style0 from "./CLtkSlideGroup.vue?vue&type=style&index=0&id=eb2d0ad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSlideGroup/CSlideGroup.vue').default})
